import React from "react"
import logo from "../../../assets/logo.png"
import { Link } from "gatsby"
import "./style.css"
import $ from 'jquery'
import './header.css'



class Header extends React.Component {

    componentDidMount = () => {
     
        $(document).ready(function(){
          $('.li-h1').click(function(){
              $('.li-h1').removeClass('active');
              $(this).addClass('active');
              
          });
         })
    
        //  $('.navbar-toggler').on('click', function () {
        //   $('.menu').addClass('thf-sidenavmenu:target');
        // });
        
        // $( '.menu a' ).on("click", function(){
        //   $('.menu').removeClass('thf-sidenavmenu:target');
        // });
  }



  render() {
    // const { location } = this.props

    // const blogLinkStyle = {
    //   paddingBottom: location.pathname === "/" ? `5px` : `0px`,
    //   boxShadow: location.pathname === "/" ? `0px 5px 0px 0px red` : `none`,
    // }
    // const broadcastsLinkStyle = {
    //   paddingBottom: location.pathname === "/broadcasts" ? `5px` : `0px`,
    //   boxShadow: location.pathname === "/broadcasts" ? `0px 5px 0px 0px red` : `none`,
    // }
    // const workLinkStyle = {
    //   paddingBottom: location.pathname === "/work" ? `5px` : `0px`,
    //   boxShadow:
    //     location.pathname === "/work" ? `0px 5px 0px 0px red` : `none`,
    // }
    // const aboutLinkStyle = {
    //   paddingBottom: location.pathname === "/about" ? `5px` : `0px`,
    //   boxShadow:
    //     location.pathname === "/about" ? `0px 5px 0px 0px red` : `none`,
    // }

    return (
      
      <nav className=" header-main navbar navbar-expand-lg navbar-light">
      {/* <div className="header-main "> */}
        <Link className="logo-link" to={`/`}>
          {/* <img src={logo} alt="22 Boxes logo" className="logo-img" /> */}
          {/* <h2 className="heading">
            Selected <br/>
            Wisdom
          </h2> */}
          <img src={logo} className="logo-image"/>
        </Link>
      <a id="main-menu-toggle" href="#thf-sidenavmenu">
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span className="navbar-toggler-icon">
    </span>
  </button>

      </a>
{/* nav collapse start */}

  {/* <a id="main-menu-toggle" href="#thf-sidenavmenu" className="d-flex  justify-content-sm-end justify-content-end">
              <i style={{ color: "#ffc107", textAlign:'right' }} class="material-icons">menu</i>
            </a> */}

{/* nav collapse end */}

        <div className="header-nav collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="nav-ul navbar-nav ml-auto">
            <li className="nav-li nav-item">
              <h1 className="li-h1" style={{color:'black !important'}}
              //  style={broadcastsLinkStyle}
              // onClick={this.handleClick}
              >
                <Link className="li-link nav-link" to={`/`} activeClassName="active">
                <span>Broadcasts</span>   
                  <div className="redBox"></div>
                </Link>
              </h1>
            </li>
            <li className="nav-li nav-item">
              <h1 className="li-h1"
              //  style={blogLinkStyle}
              // onClick={this.handleClick}
               >
                <Link className="li-link nav-link" to={`/blog/page/1`} activeClassName="active">
                  <span>Blog</span>
                  <div className="redBox">  </div>

                </Link>
              </h1>
            </li>
            <li className="nav-li nav-item">
              <h1 className="li-h1 " 
              // style={workLinkStyle}
              // onClick={this.handleClick}
              >
                <Link className="li-link nav-link" to={`/work`} activeClassName="active">
                 <span>
                  Contact
                 </span>
                  <div className="redBox"></div>
                </Link>
              </h1>
            </li>
            <li className="nav-li nav-item "
              style={{
                float: "left",
              }}
            >
              <h1 className="li-h1 " 
              // style={aboutLinkStyle}
              // onClick={this.handleClick}
              >
                <Link className="li-link nav-link" to={`/about`} activeClassName="active">
                  <span>

                  About
                  </span>
                  <div className="redBox"></div>
                </Link>
              </h1>
            </li>
          </ul>

        </div>
          
          
          
        <div id="thf-sidenavmenu" className="thf-sidenavmenu menu">
            <a href="#main-menu-toggle" className="closebtn">
              &times;
          </a>

            {/* //links */}

           
            <div className="thf-sidenav-subnav">
              <Link to="/" className="accordion">
                Broadcasts
            </Link>
            </div>
            <div className="thf-sidenav-subnav">
              <Link to="/blog/page/1" className="accordion">
                Blog
            </Link>
            </div>
            <div className="thf-sidenav-subnav">
              <Link to="/work" className="accordion">
                 Contact
            </Link>
            </div>
            <div className="thf-sidenav-subnav">
              <Link to="/about" className="accordion" >
                About
            </Link>
            </div>
            
          </div>
          <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.4.1/jquery.min.js"/>





      </nav>

   



    )
  }
}







export default Header




